import { ModuleEnum } from '@quadminds/shared/commons';
import { EventTypeEnum } from '@quadminds/shared/tracking-system';
import { JobTypeEnum, TripReportType } from '../enums';

type TJobFilters = IEventFilters | ITripFilters;

export interface IEventFilters {
    vehicleLicensePlates: string[];
    driverPhoneNumbers: string[];
    driverNames: string[];
    events: EventTypeEnum[];
}

export interface ITripFilters {
    tripDefinitionId?: string;
    driverIds?: string[];
    vehicleIds?: string[];
    carrierIds?: string[];
    organizationId?: { $in: string[] } | string;
}

export interface IReportJobData {
    from: string;
    to: string;
    resource: ModuleEnum;
    email: string;
    filters?: TJobFilters;
    additional?: {
        locale?: string;
        timezone?: string;
        reportType?: TripReportType;
    };
}

export interface ICreateJobDto {
    type: JobTypeEnum;
    data: IReportJobData;
}
